import Page from "webPage/Page";
import Track from "../util/Track";
import $ from "jquery";
import {loadMultipleGoogleMap} from "util/map-multiple";

Page.register('page-template-visiting-warwick', () => {
    new Track($('.js-track-wrap'), {
        classes: {
            block: "slider",
        },
    });

    if ($('.js-google-map').length > 0) {
        loadMultipleGoogleMap($('.js-google-map'));
    }
});